import { render, staticRenderFns } from "./EmbedGoogleReview.vue?vue&type=template&id=5b03531f&"
import script from "./EmbedGoogleReview.vue?vue&type=script&lang=js&"
export * from "./EmbedGoogleReview.vue?vue&type=script&lang=js&"
import style0 from "./EmbedGoogleReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports